import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach token from localStorage fallback (cross-domain cookies may fail)
api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("bigeldi_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function fileUrl(fileId) {
  return `${API}/files/${fileId}`;
}
